




import Vue from 'vue';

import { format } from 'date-fns';
export default Vue.extend({
  computed: {
    formattedDate() {
      const recordDate =
        (this as any).params && new Date((this as any).params.value + '+00:00');

      const isValidDate = (date: Date) => {
        return (
          Object.prototype.toString.call(date) === '[object Date]' &&
          !isNaN(date.getTime())
        );
      };

      if (isValidDate(recordDate)) {
        return format(recordDate, 'MM/dd/yyyy hh:mma');
      } else {
        return 'No date recorded';
      }
    },
  },
  props: {},
});
